import 'twin.macro';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import ButtonExternal from 'components/Buttons/ExternalLink';

export const lineBreak = <br />;
export const italic = <i />;
export const bold = <span tw="font-bold" />;
export const semibold = <span tw="font-semibold" />;
export const large = <b tw="text-lg" />;
export const nowrap = <span tw="whitespace-nowrap" />;
export const mobileHidden = <span tw="hidden md:inline-block" />;
export const arrowRight = <ArrowRightIcon tw="h-4 w-4 inline-block" />;
export const placeholderLine = (
  <p tw="text-sm text-neutral-supershy text-center [&:not(:last-child)]:mb-0" />
);

export function ExternalLink({ href }: { href: string }) {
  return (
    <ButtonExternal
      minimal
      href={href}
      small
      tw="px-1.5 text-xl text-primary"
    />
  );
}
